function Training() {
  return;
}

export default Training;
